import { QUERY_TOPIC_HINTS } from './queryHintCatalog';

/** "What can I ask?" topic chips — click fills the question input. */
export default function QueryHintChips({ onPick, className = '' }) {
  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`}>
      <span className="w-full text-[10px] font-semibold uppercase tracking-wide text-slate-500">
        What can I ask?
      </span>
      {QUERY_TOPIC_HINTS.map((topic) => (
        <button
          key={topic.id}
          type="button"
          title={topic.questions?.[0] || topic.label}
          onClick={() => onPick(topic.questions?.[0] || topic.label)}
          className="rounded-full border border-indigo-200 bg-indigo-50/80 px-2.5 py-1 text-[11px] font-medium text-indigo-800 hover:border-indigo-400 hover:bg-indigo-100"
        >
          {topic.label}
        </button>
      ))}
    </div>
  );
}
